class IframePreloader {
  constructor(element) {
    this.element = element;
    this.loader = null;
  }

  init() {
    this.hideIframe();
    this.prependLoader();
    this.element.addEventListener('load', () => {
      this.removeLoader();
      this.showIframe();
    });
  }

  hideIframe() {
    this.element.style.display = 'none';
  }

  showIframe() {
    this.element.style.display = 'block';
  }

  prependLoader() {
    this.loader = document.createElement('div');
    this.loader.className = 'iframe-preloader';
    this.element.parentNode.insertBefore(this.loader, this.element);
  }

  removeLoader() {
    this.loader.remove();
  }
}

const iframePreloader = {
  init() {
    const iframePreloaderItems = document.querySelectorAll('iframe:not([name="__gppLocator"])');

    if (iframePreloaderItems && iframePreloaderItems.length > 0) {
      iframePreloaderItems.forEach((item) => {
        const iframePreloaderItem = new IframePreloader(item);
        iframePreloaderItem.init();
      });
    }
  },
};

export default iframePreloader;
